// AUTO-GENERATED global.js
import React from "react";
import EnviromaDevices from "./views/LandLord/Devices/Devices";
import EnviromaTemperature from "./views/LandLord/Temperature/Temperature";
import WelcomeMessage from "./containers/DefaultLayout/WelcomeMessage";
import { activeFeature, wording } from "./constants/constants";
import { routes as carbonRoutes } from "./constants/carbon-constants";
import { DefaultLayout } from "./containers/index";
import History from "./views/Wallet/History/History";
import Withdrawal from "./views/Wallet/Withdrawal/Withdrawal";
import WithdrawalSettings from "./views/Wallet/WithdrawalSettings/WithdrawalSettings";
import { Redirect } from "react-router-dom";
import CameraCapture from "./views/CameraCapture/CameraCapture";
import LockBridges from "./views/Locks/LockBridges";

// React.lazy Component declarations
const LoginOTP = React.lazy(() =>
  import("./views/Users/LoginOTP/LoginOTP")
);
const DashboardDetails = React.lazy(() =>
  import("./views/Dashboard/DashboardDetails/DashboardDetails.jsx")
);
const LiveMonitoring = React.lazy(() =>
  import("./views/Fleet/LiveMonitoring/LiveMonitoringTabs")
);
const Login = React.lazy(() => import("./views/Users/Login/Login"));
const Logout = React.lazy(() => import("./views/Users/Logout/Logout"));
const Register = React.lazy(() => import("./views/Users/Register/Register"));
const UserManagement = React.lazy(() =>
  import("./views/Users/Management/Management")
);
const DeliveryOrders = React.lazy(() =>
  import("./views/Fleet/DeliveryOrders/DeliveryOrders")
);
const WorkOrders = React.lazy(() =>
  import("./views/Fleet/WorkOrders/WorkOrdersNew")
);
const ReportDeliveryOrders = React.lazy(() =>
  import("./views/Fleet/Report-DeliveryOrders/Report-DeliveryOrders")
);
const Settings = React.lazy(() => import("./views/Settings/Settings"));
const Dashboard = React.lazy(() => import("./views/Dashboard"));
const DeliveryOrderScheduleCopy = React.lazy(() =>
  import("./views/Fleet/DeliveryOrderScheduleCopy/DeliveryOrderScheduleCopy")
);
const Wallet = React.lazy(() => import("./views/Wallet/Wallet"));
const EnermoDashboard = React.lazy(() => import("./views/CarbonX/Dashboard"));
const Drivers = React.lazy(() => import("./views/Fleet/Drivers/Drivers.jsx"));
const Fleets = React.lazy(() => import("./views/Fleet/Fleets/FleetsTab"));
const CheckSheet = React.lazy(() => import("./views/Fleet/CheckSheet"));
const DOCategory = React.lazy(() => import("./views/Fleet/Category/Category"));
const Brands = React.lazy(() => import("./views/Stocker/Brands/Brands"));
const Items = React.lazy(() => import("./views/Stocker/Items/Items"));
const Vendors = React.lazy(() => import("./views/Stocker/Vendors/Vendors"));
const Opname = React.lazy(() => import("./views/Stocker/Opname/"));
const CovidMain = React.lazy(() => import("./views/Fleet/Covid/CovidMain"));
const FleetMaintenance = React.lazy(() =>
  import("./views/Fleet/FleetMaintenance/FleetMaintenanceMain.jsx")
);
const SMMechanicTask = React.lazy(() =>
  import(
    "./views/Fleet/FleetMaintenance/ScheduledMaintenance/SMMechanicTask/SMMechanicTask.jsx"
  )
);
const SMApprovalSetting = React.lazy(() =>
  import(
    "./views/Settings/FleetMaintenanceSettings/ApprovalType/ApprovalTypeSetting"
  )
);
const SMApproval = React.lazy(() =>
  import("./views/Fleet/FleetMaintenance/ScheduledMaintenance/SMApproval")
);
const SMMechanicTaskDetail = React.lazy(() =>
  import(
    "./views/Fleet/FleetMaintenance/ScheduledMaintenance/SMMechanicTask/SMMechanicTaskDetail"
  )
);
const Mechanics = React.lazy(() =>
  import("./views/Fleet/Mechanics/MechanicsMain.jsx")
);
const MechanicsCertification = React.lazy(() =>
  import(
    "./views/Fleet/Mechanics/MechanicsCertification/MechanicsCertification.jsx"
  )
);
const MechanicsSpecialization = React.lazy(() =>
  import(
    "./views/Fleet/Mechanics/MechanicsSpecialization/MechanicsSpecialization.jsx"
  )
);
const MechanicsOperationalHour = React.lazy(() =>
  import(
    "./views/Fleet/Mechanics/MechanicsOperationalHour/MechanicsOperationalHour.jsx"
  )
);
const WSMMechanicTask = React.lazy(() =>
  import(
    "./views/Fleet/FleetMaintenance/ScheduledMaintenanceWorkshop/SMMechanicTask/SMMechanicTask"
  )
);
const WSMMechanicTaskDetail = React.lazy(() =>
  import(
    "./views/Fleet/FleetMaintenance/ScheduledMaintenanceWorkshop/SMMechanicTask/SMMechanicTaskDetail"
  )
);
const Workshop = React.lazy(() =>
  import("./views/Fleet/Workshop/WorkshopMain.jsx")
);
const WorkshopOperationalHour = React.lazy(() =>
  import(
    "./views/Fleet/Workshop/WorkshopOperationalHour/WorkshopOperationalHour.jsx"
  )
);
const CurrativeOrder = React.lazy(() =>
  import("./views/Fleet/FleetMaintenance/CurrativeOrders")
);
const CheckSheetDetail = React.lazy(() =>
  import("./views/Fleet/CheckSheet/MainCheckSheet/MainCheckSheetDetail")
);
const CheckSheetApprovalSetting = React.lazy(() =>
  import("./views/Fleet/CheckSheet/ApprovalType/ApprovalTypeSetting")
);
const DoCheckSheetApproval = React.lazy(() =>
  import("./views/Fleet/DeliveryOrders/DOChecksheetApproval")
);
const PackageMaintenanceTask = React.lazy(() =>
  import(
    "./views/Settings/FleetMaintenanceSettings/PackageMaintenance/PackageMaintenanceTask"
  )
);
const PreventiveMaintenanceTask = React.lazy(() =>
  import(
    "./views/Settings/FleetMaintenanceSettings/PreventiveMaintenance/PreventiveMaintenanceTask"
  )
);
const AssetCategory = React.lazy(() =>
  import("./views/AssetTracking/AssetCategory/AssetCategory")
);
const AssetList = React.lazy(() =>
  import("./views/AssetTracking/AssetList/Assets")
);
const AssetListOBDHistory = React.lazy(() =>
  import("./views/AssetTracking/AssetList/History/AssetListHistory")
);
const AssetListOBDHistoryV2 = React.lazy(() =>
  import("./views/AssetTracking/AssetList/History/AssetListOBDHistory")
);
const AssetTrackingMap = React.lazy(() =>
  import("./views/AssetTracking/AssetTrackingMap/AssetTracking")
);

//Landlord
const LandLordDashboard = React.lazy(() =>
  import("./views/LandLord/Dashboard/Dashboard.jsx")
);
const LandLordLocationType = React.lazy(() =>
  import("./views/LandLord/LocationType/LLLocationType.jsx")
);
const LandLordLocation = React.lazy(() =>
  import("./views/LandLord/Location/LLLocation.jsx")
);
const LandLordSensors = React.lazy(() =>
  import("./views/LandLord/Sensors/LLSensors.jsx")
);
const LandLordSensorInstallation = React.lazy(() =>
  import("./views/LandLord/SensorInstallation/LLSensorInstallation.jsx")
);
const LandLordUtility = React.lazy(() =>
  import("./views/LandLord/Utility/Utility.jsx")
);

const EnermoSettings = React.lazy(() =>
  import("./views/Enermo/Settings/Enermo-Setting")
);
const MonitorDetails = React.lazy(() =>
  import("./views/Fleet/MonitorDetails/MonitorDetails.jsx")
);
const DriversAssistant = React.lazy(() =>
  import("./views/Fleet/DriverAssistants/DriverAssistants.jsx")
);
const FleetsObdHistory = React.lazy(() =>
  import("./views/Fleet/Fleets/FleetObdHistory.jsx")
);
const FleetOperations = React.lazy(() =>
  import("./views/Fleet/FleetOperations/FleetOperations.jsx")
);
const SavedPlaces = React.lazy(() =>
  import("./views/Fleet/SavedPlaces/SavedPlaces.jsx")
);
const PublicFacility = React.lazy(() =>
  import("./views/Fleet/PublicFacility/Tabs")
);
const MainCustomer = React.lazy(() =>
  import("./views/Fleet/MainCustomer/MainCustomer.jsx")
);
const LiveMonitoringCommandCenter = React.lazy(() =>
  import("./views/Fleet/LiveMonitoringCommandCenter/LiveMonitoringCCWrapper")
);
const Security = React.lazy(() =>
  import("./views/Fleet/Security/Security.jsx")
);
const FleetsReport = React.lazy(() =>
  import("./views/Fleet/Fleets/Fleets-Report")
);
const FuelReport = React.lazy(() =>
  import("./views/Fleet/Fleets/FuelReport/FleetFuelReport")
);
const DeliveryAudit = React.lazy(() =>
  import("./views/Fleet/DeliveryOrders/DeliveryOrderAudit/DeliveryOrderAudit")
);
const TriPLWorkOrderRequest = React.lazy(() =>
  import("./views/Fleet/3PL/Request/TriPLRequest")
);
const TriPLAdministrative = React.lazy(() =>
  import("./views/Fleet/3PL/Administrative/TriPLAdministrative")
);
const TriPLGrouping = React.lazy(() =>
  import("./views/Fleet/3PL/Grouping/TriPLGroupingTabs")
);
const GroupMembersAssign = React.lazy(() =>
  import("./views/Fleet/3PL/Grouping/GroupMembersAssign/GroupMembersAssign")
);
const WOReview = React.lazy(() =>
  import("./views/Fleet/Report/WOReview/WOReview")
);
const WOPODConfirmReview = React.lazy(() =>
  import("./views/Fleet/Report/WOPODVerif/WOPODVerif")
);

const TransporterDivisions = React.lazy(() =>
  import("./views/Fleet/Divisions")
);
// Stocker
const AdministrationOffices = React.lazy(() =>
  import("./views/Stocker/AdministrationOffices/AdministrationOffices")
);
const Batchs = React.lazy(() =>
  import("./views/Stocker/Batch/MasterBatchs/MasterBatchs")
);
const CompanyBankAccounts = React.lazy(() =>
  import("./views/Stocker/CompanyBankAccounts/CompanyBankAccounts")
);
const Divisions = React.lazy(() =>
  import("./views/Stocker/Divisions/Divisions")
);
const Inbounds = React.lazy(() =>
  import("./views/Stocker/Inbounds/MasterInbound/MasterInbound")
);
const InboundDetail = React.lazy(() =>
  import("./views/Stocker/Inbounds/InboundDetails/InboundDetails")
);
const InboundItemDetail = React.lazy(() =>
  import("./views/Stocker/Inbounds/InboundItemDetails/InboundItemDetails")
);
const InboundDriverOfficer = React.lazy(() =>
  import("./views/Stocker/Inbounds/InboundDriverOfficer/InboundDriverOfficer")
);
const InboundOfficerAssistant = React.lazy(() =>
  import(
    "./views/Stocker/Inbounds/InboundOfficerAssistants/InboundOfficerAssistants"
  )
);
const InboundVehicle = React.lazy(() =>
  import("./views/Stocker/Inbounds/InboundVehicles/InboundVehicles")
);
const Outbounds = React.lazy(() =>
  import("./views/Stocker/Outbounds/Outbounds")
);
const OutboundDetail = React.lazy(() =>
  import("./views/Stocker/Outbounds/OutboundDetails/OutboundDetails")
);
const OutboundItemDetail = React.lazy(() =>
  import("./views/Stocker/Outbounds/OutboundItemDetails/OutboundItemDetails")
);
const ItemDetail = React.lazy(() =>
  import("./views/Stocker/Items/MasterItemDetails/MasterItemDetailTab")
);
const ItemSettings = React.lazy(() =>
  import("./views/Stocker/ItemSettings/ItemSettings")
);
const ItemDisposalDetail = React.lazy(() =>
  import(
    "./views/Stocker/DisposalItems/DisposalItemDetails/DisposalItemDetails"
  )
);
const OperatingAreas = React.lazy(() =>
  import("./views/Stocker/OperatingAreas/OperatingAreas")
);
const OperatingAreaGeofence = React.lazy(() =>
  import("./views/Stocker/OperatingAreaGeofences/OperatingAreaGeofences")
);
const PurchaseOrder = React.lazy(() =>
  import("./views/Stocker/PurchaseOrder/PurchaseOrder")
);
const PurchaseOrderApproval = React.lazy(() =>
  import(
    "./views/Stocker/PurchaseOrder/PurchaseOrderApprovals/PurchaseOrderApprovals"
  )
);
const PurchaseOrderPayment = React.lazy(() =>
  import(
    "./views/Stocker/PurchaseOrder/PurchaseOrderPayments/PurchaseOrderPayments"
  )
);
const PurchaseOrderPrintJob = React.lazy(() =>
  import(
    "./views/Stocker/PurchaseOrder/PurchaseOrderPrintJob/PurchaseOrderPrintJob"
  )
);
const PurchaseOrderItemDetail = React.lazy(() =>
  import(
    "./views/Stocker/PurchaseOrder/PurchaseOrderItemDetails/PurchaseOrderItemDetails"
  )
);
const PurchaseOrderItemDetailsIntercompany = React.lazy(() =>
  import(
    "./views/Stocker/PurchaseOrder/PurchaseOrderItemDetailsIntercompany/PurchaseOrderItemDetailsIntercompany"
  )
);
const PaymentTerms = React.lazy(() =>
  import("./views/Stocker/PaymentTerms/PaymentTerms")
);
const Repacakaging = React.lazy(() =>
  import("./views/Stocker/Repackaging/Repacakaging")
);
const RepacakagingItemDetail = React.lazy(() =>
  import("./views/Stocker/Repackaging/RepackagingItem/RepackagingItemDetails")
);
const ReturnOrder = React.lazy(() =>
  import("./views/Stocker/ReturnOrder/ReturnOrder")
);
const SalesOrder = React.lazy(() =>
  import("./views/Stocker/SalesOrder/SalesOrder")
);
const SalesOrderApproval = React.lazy(() =>
  import("./views/Stocker/SalesOrder/SalesOrderApprovals/SalesOrderApprovals")
);
const SalesOrderPayment = React.lazy(() =>
  import("./views/Stocker/SalesOrder/SalesOrderPayments/SalesOrderPayments")
);
const SalesOrderPrintJob = React.lazy(() =>
  import("./views/Stocker/SalesOrder/SalesOrderPrintJob/SalesOrderPrintJob")
);
const SalesOrderItemDetail = React.lazy(() =>
  import(
    "./views/Stocker/SalesOrder/SalesOrderItemDetails/SalesOrderItemDetails"
  )
);
const SalesOrderItemDetailIntercompany = React.lazy(() =>
  import(
    "./views/Stocker/SalesOrder/SalesOrderItemDetailsIntercompany/SalesOrderItemDetails"
  )
);
const StockerPicPositions = React.lazy(() =>
  import("./views/Stocker/PicPositions/PicPositions")
);
const VendorPICPersons = React.lazy(() =>
  import("./views/Stocker/VendorPicPersons/VendorPicPersons")
);
const VendorsBankAccounts = React.lazy(() =>
  import("./views/Stocker/VendorsBankAccounts/VendorsBankAccounts")
);
const Warehouse = React.lazy(() =>
  import("./views/Stocker/Warehouse/Warehouse")
);
const WarehouseArea = React.lazy(() =>
  import("./views/Stocker/Warehouse/WarehouseAreas/WarehouseAreas")
);
const WarehouseAreaGeofence = React.lazy(() =>
  import("./views/Stocker/Warehouse/WarehouseGeofence/WarehouseGeofence")
);
const WarehouseTransfers = React.lazy(() =>
  import("./views/Stocker/WarehouseTransfers/WarehouseTransfers")
);
const WarehouseTransferApprovals = React.lazy(() =>
  import(
    "./views/Stocker/WarehouseTransfers/WarehouseTransferApprovals/WarehouseTransferApprovals"
  )
);
const WarehouseTransferDetails = React.lazy(() =>
  import(
    "./views/Stocker/WarehouseTransfers/MasterWarehouseTransferDetail/MasterWarehouseTransferDetail"
  )
);
const WarehouseTransferItem = React.lazy(() =>
  import(
    "./views/Stocker/WarehouseTransfers/WarehouseTransferItem/WarehouseTransferItem"
  )
);
const IncomingGoods = React.lazy(() => import("./views/Stocker/IncomingGoods"));
const InvoicePage = React.lazy(() =>
  import("./views/Stocker/InvoicePage/InvoicePage")
);
const InvoiceItemDetail = React.lazy(() =>
  import("./views/Stocker/InvoicePage/InvoiceItemDetails/InvoiceItemDetails")
);
const RackManagement = React.lazy(() =>
  import("./views/Stocker/RackManagement/RackManagement")
);
const OpnameTaskDetail = React.lazy(() =>
  import("./views/Stocker/Opname/TaskDetail")
);
const IOTBindingUserAndDevice = React.lazy(() =>
  import("./views/Stocker/IOTBinding/UserAndDevice/UserAndDevice")
);
const IOTBindingItemBox = React.lazy(() =>
  import("./views/Stocker/IOTBinding/ItemBox/ItemBox")
);
const Tagging = React.lazy(() =>
  import("./views/Stocker/IOTBinding/Tagging/Tagging")
);
//Point Hub
const Customers = React.lazy(() =>
  import("./views/PointHub/Customers/Customers")
);
const CustomerBankAccounts = React.lazy(() =>
  import("./views/PointHub/CustomerBankAccounts/CustomerBankAccounts")
);
const CustomerApprovals = React.lazy(() =>
  import("./views/PointHub/CustomerApproval/CustomerApproval")
);
const PicPositions = React.lazy(() =>
  import("./views/PointHub/PicPositions/PicPositions")
);
const CustomerPic = React.lazy(() =>
  import("./views/PointHub/CustomersPIC/CustomersPIC")
);
const MaintenanceWorkshop = React.lazy(() =>
  import("./views/PointHub/MaintenanceWorkshop")
);
const Rentee = React.lazy(() =>
  import("./views/PointHub/Rentee/RenteeGroupingTabs")
);
const RenteeMemberAssign = React.lazy(() =>
  import("./views/PointHub/Rentee/GroupMembersAssign/GroupMembersAssign")
);
const TradingIntercompanyVendor = React.lazy(() =>
  import("./views/PointHub/TradingIntercompanyPair/ConnectAsVendor")
);
const TradingIntercompanyCustomer = React.lazy(() =>
  import("./views/PointHub/TradingIntercompanyPair/ConnectAsCustomer")
);
const IntercompanyOrder = React.lazy(() =>
  import("./views/PointHub/IntercompanyOrder/IntercompanyOrder")
);
const IntercompanyOrderCard = React.lazy(() =>
  import(
    "./views/PointHub/IntercompanyOrder/IntercompanyOrderCart/IntercompanyOrderCart"
  )
);
const IntercompanyOrderShipment = React.lazy(() =>
  import(
    "./views/PointHub/IntercompanyOrder/IntercompanyOrderCart/IntercompanyOrderShipment/IntercompanyOrderShipment"
  )
);
const IntercompanyOrderItem = React.lazy(() =>
  import(
    "./views/PointHub/IntercompanyOrder/IntercompanyOrderItem/IntercompanyOrderItem"
  )
);

const Subscriptions = React.lazy(() =>
  import("./views/Subscriptions/Subscriptions")
);
const DriverAppUsers = React.lazy(() =>
  import("./views/Fleet/DriverAppUsers/DriverAppUsers.jsx")
);
const MaintenanceSettings = React.lazy(() =>
  import("./views/Settings/FleetMaintenanceSettings")
);

const GeocodeConverter = React.lazy(() =>
  import("./views/Tools/GeocodeConverter/GeocodeConverter")
);

const MyPertaminaConverter = React.lazy(() =>
  import("./views/Tools/MyPertaminaConverter/MyPertaminaConverter")
);

const CarbonInvoice = React.lazy(() =>
  import("./views/CarbonX/CarbonInvoice/")
);

// Carbon X Lama
const LoggerScope1 = React.lazy(() =>
  import("./views/CarbonX/Logger/Scope1/Scope1Tab")
);
const LoggerScope2 = React.lazy(() =>
  import("./views/Enermo/Dashboard/index-new")
);
const LoggerScope3 = React.lazy(() =>
  import("./views/CarbonX/Logger/Scope3/Scope3Tab")
);
const UserVerification = React.lazy(() =>
  import("./views/Users/Verification/")
);

const routes = [
  {
    files: ["guests"],
    path: "/validation/user/:authtoken",
    name: "Verify",
    Component: UserVerification,
  },
  {
    files: [],
    path: "/register",
    name: "Register",
    Component: Register,
  },

  {
    files: ["guests"],
    path: "/login/otp",
    name: "Login OTP",
    Component: LoginOTP,
  },
  {
    files: ["guests"],
    path: "/login",
    name: "Login",
    Component: Login,
  },
  {
    files: [
      "securityRoutes.jsx",
      "goodsTraderIntercompanyRoutes.jsx",
      "hrRoutes.jsx",
      "maintenanceRoutes.jsx",
      "managerRoutes.jsx",
      "routes.js",
      "guests",
    ],
    path: "/logout",
    name: "Logout",
    Component: Logout,
  },
  {
    files: [
      "securityRoutes.jsx",
      "goodsTraderIntercompanyRoutes.jsx",
      "hrRoutes.jsx",
      "maintenanceRoutes.jsx",
      "managerRoutes.jsx",
      "routes.js",
      "guests",
    ],
    path: "/",
    name: "Default",
    Component: DefaultLayout,
    exact: true,
    private: true,
    children: [
      {
        files: ["routes.js"],
        path: "/asset-tracking/category",
        name: "Asset Category",
        Component: AssetCategory,
        exact: true,
      },
      {
        files: ["routes.js"],
        path: "/asset-tracking/list",
        name: "Asset List",
        Component: AssetList,
        exact: true,
      },
      {
        files: ["routes.js"],
        path: "/asset-tracking/map",
        name: "Asset Tracking Maps",
        Component: AssetTrackingMap,
        exact: true,
      },
      {
        files: ["routes.js"],
        path: "/asset-tracking/obd-history-v2/:id_asset",
        name: "Asset List OBD History V2",
        Component: AssetListOBDHistoryV2,
        exact: true,
      },
      {
        files: ["routes.js"],
        path: "/asset-tracking/obd-history/:id_asset/:id_obd",
        name: "Asset OBD History List",
        Component: AssetListOBDHistory,
        exact: true,
      },
      // carbonx v1
      ...(activeFeature.CARBONX_V2
        ? carbonRoutes
        : [
            {
              files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
              path: "/carbonx/invoice/",
              name: "Carbon Invoice",
              Component: CarbonInvoice,
              exact: true,
            },
            {
              files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
              path: "/carbonx/logger/scope1",
              name: "Logger Scope 1",
              Component: LoggerScope1,
              exact: true,
            },
            {
              files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
              path: "/carbonx/logger/scope2",
              name: "Logger Scope 2",
              Component: LoggerScope2,
              exact: true,
            },
            {
              files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
              path: "/carbonx/logger/scope3",
              name: "Logger Scope 3",
              Component: LoggerScope3,
              exact: true,
            },
          ]),
      // carbonx v2 -- end
      {
        files: ["securityRoutes.jsx", "managerRoutes.jsx"],
        path: "/dashboard/details",
        name: "Details",
        Component: DashboardDetails,
      },
      {
        files: ["managerRoutes.jsx"],
        path: "/enviroma/devices",
        name: "Enviroma Devices",
        Component: EnviromaDevices,
      },
      {
        files: ["managerRoutes.jsx"],
        path: "/enviroma/temperature",
        name: "Enviroma Temperature",
        Component: EnviromaTemperature,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/enermo/dashboard",
        name: "CarbonX Dashboard",
        Component: EnermoDashboard,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/enermo/settings",
        name: "CarbonX Settings",
        Component: EnermoSettings,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/landlord/dashboard",
        name: "Land Lord Monitoring",
        Component: LandLordDashboard,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/landlord/devices",
        name: "Land Lord Devices",
        Component: EnviromaDevices,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/landlord/locations",
        name: "Land Lord Locations",
        Component: LandLordLocation,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/landlord/locationtype",
        name: "Land Lord Location Type",
        Component: LandLordLocationType,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/landlord/sensors",
        name: "Land Lord Sensors",
        Component: LandLordSensors,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/landlord/sensors/installation/:id",
        name: "Land Lord Sensors Installation",
        Component: LandLordSensorInstallation,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/landlord/temperature",
        name: "Enviroma Temperature",
        Component: EnviromaTemperature,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/landlord/utilities",
        name: "Land Lord Utilities",
        Component: LandLordUtility,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/point-hub/customer-approvals",
        name: "Point Hub Customer Approvals",
        Component: CustomerApprovals,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/point-hub/customer-bank-accounts",
        name: "Point Hub Customer Bank Accounts",
        Component: CustomerBankAccounts,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/point-hub/customer-pic",
        name: "Point Hub Customer PIC",
        Component: CustomerPic,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/point-hub/customers",
        name: "Point Hub Customers",
        Component: Customers,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/point-hub/intercompany-order",
        name: "Intercompany Order",
        Component: IntercompanyOrder,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/point-hub/intercompany-order/cart",
        name: "Cart",
        Component: IntercompanyOrderCard,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/point-hub/intercompany-order/cart/shipment",
        name: "Shipment",
        Component: IntercompanyOrderShipment,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/point-hub/intercompany-order/item/:id",
        name: "Item",
        Component: IntercompanyOrderItem,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/point-hub/intercompany-trading/customer",
        name: "Trading Intercompany Connection",
        Component: TradingIntercompanyCustomer,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/point-hub/intercompany-trading/vendor",
        name: "Trading Intercompany Connection",
        Component: TradingIntercompanyVendor,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/point-hub/maintenance-workshop",
        name: "Maintenance Workshop",
        Component: MaintenanceWorkshop,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/point-hub/pic-positions",
        name: "Point Hub PIC Position",
        Component: PicPositions,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/point-hub/rentee",
        name: "Rentee",
        Component: Rentee,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/point-hub/rentee/group-members-assign/:id",
        name: "Rentee",
        Component: RenteeMemberAssign,
        exact: true,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/settings",
        name: "Settings",
        Component: Settings,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/administrative-offices",
        name: "Stocker Administration Offices",
        Component: AdministrationOffices,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/batchs",
        name: "Stocker Batchs",
        Component: Batchs,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/brands",
        name: "Stocker Brands",
        Component: Brands,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/company-bank-accounts",
        name: "Stocker Company Bank Accounts",
        Component: CompanyBankAccounts,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/divisions",
        name: "Stocker Divisions",
        Component: Divisions,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/inbound-detail/:id",
        name: "Stocker Inbound Detail",
        Component: InboundDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/inbound-driver-officer/:id",
        name: "Stocker Driver Officer",
        Component: InboundDriverOfficer,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/inbound-item-detail/:id",
        name: "Stocker Inbound Item Detail",
        Component: InboundItemDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/inbound-officer-assistant/:id",
        name: "Stocker Officer Assistant",
        Component: InboundOfficerAssistant,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/inbound-vehicle/:id",
        name: "Stocker Inbound Vehicle",
        Component: InboundVehicle,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/inbounds",
        name: "Stocker Inbounds",
        Component: Inbounds,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/stocker/incoming-goods",
        name: "Stocker Incoming Goods",
        Component: IncomingGoods,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/stocker/invoice-page",
        name: "Stocker Invoice Page",
        Component: InvoicePage,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/stocker/invoice-page/item-detail",
        name: "Stocker Invoice Item Detail",
        Component: InvoiceItemDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/item-box",
        name: "IOT Binding Item Box",
        Component: IOTBindingItemBox,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/item-detail/:id",
        name: "Stocker Item Detail",
        Component: ItemDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/item-disposal-detail/:id",
        name: "Stocker Disposal Item Detail",
        Component: ItemDisposalDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/item-settings",
        name: "Stocker Item Settings",
        Component: ItemSettings,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/items",
        name: "Stocker Items",
        Component: Items,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/operating-area-geofence/:id",
        name: "Stocker Operating Area Geofence",
        Component: OperatingAreaGeofence,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/operating-areas",
        name: "Stocker Operating Areas",
        Component: OperatingAreas,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/opname/",
        name: "Stocker Opname",
        Component: Opname,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/opname/task-detail/:id",
        name: "Stocker My Opname Task Detail",
        Component: OpnameTaskDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/outbound-detail/:id",
        name: "Stocker Outbound Detail",
        Component: OutboundDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/outbound-item-detail/:id",
        name: "Stocker Outbound Item Detail",
        Component: OutboundItemDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/outbounds",
        name: "Stocker Outbounds",
        Component: Outbounds,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/payment-term",
        name: "Stocker Payment Terms",
        Component: PaymentTerms,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/pic-positions",
        name: "Stocker PIC Positions",
        Component: StockerPicPositions,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/purchase-order",
        name: "Stocker Purchase Order",
        Component: PurchaseOrder,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/purchase-order-approval/:id",
        name: "Stocker Purchase Order",
        Component: PurchaseOrderApproval,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/stocker/purchase-order-intercompany-item-detail/:id",
        name: "Stocker Purchase Order Item Detail Intercompany",
        Component: PurchaseOrderItemDetailsIntercompany,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/purchase-order-item-detail/:id",
        name: "Stocker Purchase Order Item Detail",
        Component: PurchaseOrderItemDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/purchase-order-payment/:id",
        name: "Stocker Purchase Order",
        Component: PurchaseOrderPayment,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/purchase-order-print-job/:id",
        name: "Stocker Purchase Order",
        Component: PurchaseOrderPrintJob,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/rack-management",
        name: "Rack Management",
        Component: RackManagement,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/repacakaging",
        name: "Stocker Repackaging",
        Component: Repacakaging,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/repackaging-item-detail/:id",
        name: "Stocker Repackaging Item Detail",
        Component: RepacakagingItemDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/return-order",
        name: "Stocker Return Order",
        Component: ReturnOrder,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/sales-order",
        name: "Stocker Sales Order",
        Component: SalesOrder,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/sales-order-approval/:id",
        name: "Stocker Sales Order",
        Component: SalesOrderApproval,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx"],
        path: "/stocker/sales-order-intercompany-item-detail/:id",
        name: "Stocker Sales Order Item Detail Intercompany",
        Component: SalesOrderItemDetailIntercompany,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/sales-order-item-detail/:id",
        name: "Stocker Sales Order Item Detail",
        Component: SalesOrderItemDetail,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/sales-order-payment/:id",
        name: "Stocker Sales Order",
        Component: SalesOrderPayment,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/sales-order-print-job/:id",
        name: "Stocker Sales Order",
        Component: SalesOrderPrintJob,
        exact: true,
      },
      {
        files: ["routes.js"],
        path: "/stocker/tagging",
        name: "IOT Binding Tagging",
        Component: Tagging,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/user-and-device",
        name: "IOT Binding User and Device",
        Component: IOTBindingUserAndDevice,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/vendor-pic-persons/:id",
        name: "Stocker Vendors PIC Persons",
        Component: VendorPICPersons,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/vendors",
        name: "Stocker Vendors",
        Component: Vendors,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/vendors-bank-accounts/:id",
        name: "Stocker Vendors Bank Accounts",
        Component: VendorsBankAccounts,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/warehouse",
        name: "Stocker Warehouse",
        Component: Warehouse,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/warehouse-areas-geofence/:id",
        name: "Stocker Warehouse Areas Geofence",
        Component: WarehouseAreaGeofence,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/warehouse-areas/:id",
        name: "Stocker Warehouse Areas",
        Component: WarehouseArea,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/warehouse-transfer",
        name: "Stocker Warehouse Transfers",
        Component: WarehouseTransfers,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/warehouse-transfer-approval/:id",
        name: "Stocker Warehouse Transfer Approval",
        Component: WarehouseTransferApprovals,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/warehouse-transfer-detail/:id",
        name: "Stocker Warehouse Transfer Detail",
        Component: WarehouseTransferDetails,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/stocker/warehouse-transfer-item/:id",
        name: "Stocker Warehouse Item Detail",
        Component: WarehouseTransferItem,
        exact: true,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/subscriptions",
        name: "Subscriptions",
        Component: Subscriptions,
      },
      {
        files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
        path: "/tools/geocode-converter",
        name: "Geocode Converter",
        Component: GeocodeConverter,
        exact: true,
      },
      // {
      //   files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
      //   path: "/tools/mypertamina-converter",
      //   name: "MyPertamina Converter",
      //   Component: MyPertaminaConverter,
      //   exact: true,
      // },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/3pl/administrative",
        name: "3PL Administrative",
        Component: TriPLAdministrative,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/3pl/group-members-assign/:id",
        name: "3PL Work Order Grouping Member Assign",
        Component: GroupMembersAssign,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/3pl/grouping",
        name: "3PL Work Order Grouping",
        Component: TriPLGrouping,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/3pl/request",
        name: "3PL Work Order Request",
        Component: TriPLWorkOrderRequest,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/check-sheet",
        name: "Check Sheet",
        Component: CheckSheet,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/check-sheet/approval-setting/:id",
        name: "Check Sheet Approval Setting",
        Component: CheckSheetApprovalSetting,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/check-sheet/details/:id",
        name: "Check Sheet Detail",
        Component: CheckSheetDetail,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/command-center",
        name: "Live Monitoring Command Center",
        Component: LiveMonitoringCommandCenter,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/covid-related/:id",
        name: "Covid Related",
        Component: CovidMain,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/currative-order",
        name: "Currative Order",
        Component: CurrativeOrder,
        exact: true,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/dashboard",
        name: "Dashboard",
        Component: Dashboard,
        exact: true,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/delivery-order",
        name: wording["Delivery Order"],
        Component: DeliveryOrders,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/delivery-order-schedule-copy",
        name: wording["Delivery Order"] + " Schedule Copy",
        Component: DeliveryOrderScheduleCopy,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/delivery/audit/:id",
        name: wording["Delivery Order"] + " Audit",
        Component: DeliveryAudit,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/delivery/category",
        name: "Category",
        Component: DOCategory,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/divisions",
        name: "Divisions",
        Component: TransporterDivisions,
        exact: true,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/do-check-sheet/approval/:id",
        name: "Do Check Sheet Approval",
        Component: DoCheckSheetApproval,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/driver-app-user/:id",
        name: "Driver App Users",
        Component: DriverAppUsers,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/drivers",
        name: "Drivers",
        Component: Drivers,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/drivers-assistant",
        name: "Drivers Assistant",
        Component: DriversAssistant,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleet-maintenance",
        name: "Fleet Maintenance",
        Component: FleetMaintenance,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleet-maintenance-settings",
        name: "Fleet Maintenance Settings",
        Component: MaintenanceSettings,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleet-maintenance/mechanic-task-detail/:id",
        name: "Scheduled Maintenance Mechanic Task Detail",
        Component: SMMechanicTaskDetail,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleet-maintenance/mechanic-task/:id",
        name: "Scheduled Maintenance Mechanic Task",
        Component: SMMechanicTask,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleet-maintenance/workshop-mechanic-task-detail/:id",
        name: "Scheduled Maintenance Mechanic Task Detail",
        Component: WSMMechanicTaskDetail,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleet-maintenance/workshop-mechanic-task/:id",
        name: "Scheduled Maintenance Mechanic Task",
        Component: WSMMechanicTask,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleet-operations",
        name: "Fleet Operations",
        Component: FleetOperations,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleets",
        name: "Fleets",
        Component: Fleets,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleets/fuel/report/:id",
        name: "Fuel Report",
        Component: FuelReport,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleets/obd-history/:id",
        name: "Fleet OBD History",
        Component: FleetsObdHistory,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/fleets/report/:id",
        name: "Fleet Report",
        Component: FleetsReport,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/live-monitoring",
        name: "Live Monitoring",
        Component: LiveMonitoring,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/main-customers",
        name: "Main Customers",
        Component: MainCustomer,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/mechanics",
        name: "Mechanics",
        Component: Mechanics,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/mechanics/certification/:id",
        name: "Mechanics Certification",
        Component: MechanicsCertification,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/mechanics/operational-hour/:id",
        name: "Mechanics Operational Hour",
        Component: MechanicsOperationalHour,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/mechanics/specialization/:id",
        name: "Mechanics Specialization",
        Component: MechanicsSpecialization,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/monitoring/details",
        name: "Monitor Details",
        Component: MonitorDetails,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/package-maintenance-task/:id",
        name: "Package Maintenance",
        Component: PackageMaintenanceTask,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/preventive-maintenance-task/:id",
        name: "Preventive Maintenance",
        Component: PreventiveMaintenanceTask,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/public-facility",
        name: "Public Facilty",
        Component: PublicFacility,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/report/delivery/:id",
        name: wording["Delivery Order"] + " Report",
        Component: ReportDeliveryOrders,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/saved-places",
        name: "Saved Places",
        Component: SavedPlaces,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/scheduled-maintenance/approval-setting/:id",
        name: "Scheduled Maintenance Approval Setting",
        Component: SMApprovalSetting,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/scheduled-maintenance/approval/:id",
        name: "Scheduled Maintenance Approval",
        Component: SMApproval,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/security",
        name: "Security",
        Component: Security,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/wo-pod-verif-review/:id",
        name: "Work Order POD Verification Review",
        Component: WOPODConfirmReview,
        exact: true,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/wo-review/:month/:id",
        name: "Work Order Review",
        Component: WOReview,
        exact: true,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/work-order/:id",
        name: "Work Order",
        Component: WorkOrders,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/workshop",
        name: "Workshop",
        Component: Workshop,
        exact: true,
      },
      {
        files: [
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
        ],
        path: "/transporter/workshop/operational-hour/:id",
        name: "Workshop Operational Hour",
        Component: WorkshopOperationalHour,
        exact: true,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/user/management",
        name: "User Management",
        Component: UserManagement,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/wallet",
        name: "Wallet",
        Component: Wallet,
        children: [
          {
            files: [
              "securityRoutes.jsx",
              "goodsTraderIntercompanyRoutes.jsx",
              "hrRoutes.jsx",
              "maintenanceRoutes.jsx",
              "managerRoutes.jsx",
              "routes.js",
            ],
            path: "/wallet/history",
            name: "History",
            exact: true,
            Component: History,
          },
          {
            files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
            path: `/wallet/widthdrawal`,
            name: "Widthdrawal",
            exact: true,
            Component: Withdrawal,
          },
          {
            files: ["goodsTraderIntercompanyRoutes.jsx", "routes.js"],
            path: `/wallet/widthdrawal-settings`,
            name: "Widthdrawal Settings",
            exact: true,
            Component: WithdrawalSettings,
          },
          {
            files: [
              "securityRoutes.jsx",
              "goodsTraderIntercompanyRoutes.jsx",
              "hrRoutes.jsx",
              "maintenanceRoutes.jsx",
              "managerRoutes.jsx",
              "routes.js",
            ],
            path: "/wallet",
            name: "Wallet",
            Component: () => <></>,
          },
        ],
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "mechanicRoutes.jsx",
          "routes.js",
          "guests"
        ],
        path: "/welcome",
        name: "Welcome Message",
        Component: WelcomeMessage,
        exact: true,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/",
        Component: () => <Redirect to="/welcome" />,
        exact: true,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/camera",
        Component: CameraCapture,
        exact: true,
      },
      {
        files: [
          "securityRoutes.jsx",
          "goodsTraderIntercompanyRoutes.jsx",
          "hrRoutes.jsx",
          "maintenanceRoutes.jsx",
          "managerRoutes.jsx",
          "routes.js",
        ],
        path: "/locks",
        Component: LockBridges,
        exact: true,
      },
    ],
  },
];

export default routes;
